import React, { Fragment, useState, useCallback, useRef, useEffect } from "react";
import { useInput, FileField, useFormContext, useDataProvider, useTranslate } from 'react-admin';
import { Card, Typography, CardContent, TextField as MUITextField, Button, Box, Dialog, DialogActions, DialogContent, DialogContentText,DialogTitle } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useFormState } from 'react-final-form';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import { useStyles } from "./FileManager.styles";
import { bytesToSize } from './FileManager.utils';

const RemoveIcon = () => <svg viewBox="0 0 40 40">
	<path
		stroke="current"
		strokeLinecap="round"
		strokeWidth="4"
		d="M 10,10 L 30,30 M 30,10 L 10,30"
	/>
</svg>;
const UploadIcon = ({className}) => <svg className={className} fill="#e6e6e6" viewBox="0 0 512 512">
	<path d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/>
</svg>;

const FilesInputItem = ({ data, confirmRemoveItem, handleFileDataChange }) => {
	const translate = useTranslate();
	const classes = useStyles();
	const {
		uid,
		name,
		size,
		previewUrl,
	} = data;
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({id: uid});
	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return <div ref={setNodeRef} style={style} {...attributes} className={classes.filesItem}>
		<div className={classes.filesItemImageData}>
			{(name || size) && (
				<div className={classes.filesItemName}>
					<div>
						{name}
						{size && <div className={classes.filesItemSize}>
							<UploadIcon className={classes.filesInputUploadIcon} />
							<span>{bytesToSize(size)}</span>
						</div>}
					</div>
				</div>
			)}

			<div
				style={{ backgroundImage: `url(${previewUrl})` }}
				className={classes.filesItemImage}
				{...listeners}
			/>

			<div className={classes.filesItemRemove} onClick={() => confirmRemoveItem(data)}>
				<RemoveIcon />
			</div>
		</div>

		{'caption' in data &&
			<MUITextField
				fullWidth
				size="small"
				variant="filled"
				margin="none"
				label={translate('ra.fileManager.caption')}
				value={data.caption ?? ''}
				onChange={(e) => handleFileDataChange(uid, 'caption', e.target.value)} />}
	</div>;
};

export default FilesInputItem;